export const normalizeExpedienteId = (value) => {
  const raw = (value ?? "").toString().trim();

  if (!raw) return "";

  const compactValue = raw.replace(/\s+/g, "");
  const withoutLeadingZeros = compactValue.replace(/^0+/, "");

  return withoutLeadingZeros || "0";
};

export const buildClientSignPath = (expedienteId) => {
  const normalizedId = normalizeExpedienteId(expedienteId);
  if (!normalizedId) return "/client-sign";

  return `/client-sign?id=${encodeURIComponent(normalizedId)}`;
};
